import * as React from 'react';
import { Link } from 'react-router-dom';
import "./Notifications.scss";

interface INotification {
    linkText: string;
    linkTo: string;
    state: any;
    amount: number;
}

export const Notification: React.FunctionComponent<INotification> = ({ amount, linkText, linkTo, state }) => {

    return (
        <>
            {
                <h4 className="notification">
                    <Link className="notification-link" to={{ pathname: linkTo, state: state }} >
                        {linkText}
                    </Link>
                    <div className="notification-amount badge badge-primary">{amount}</div>
                </h4>
            }
        </>
    )
}